import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DangerousIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dangerous"}/>
}
